import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PublicLayout, { H1, Lead, SectionCta } from "../../components/PublicLayout";
import { SITE } from "../../content/site";
import { routePath, SITE_URL } from "../../lib/routes";
import { orgRef } from "../../components/Seo";
import { track, EVENTS } from "../../lib/analytics";

export default function Services({ lang }) {
  const c = SITE[lang].services;
  useEffect(() => { window.scrollTo(0, 0); track(EVENTS.SERVICE_VIEWED, { page: "services" }); }, [lang]);
  const ld = [{
    "@context": "https://schema.org", "@type": "WebPage",
    name: c.h1, url: `${SITE_URL}${routePath("services", lang)}`, inLanguage: lang,
    about: c.sections.map((s) => ({ "@type": "Service", name: s.name, provider: orgRef(), areaServed: "Worldwide", audience: { "@type": "Audience", audienceType: "Equestrian businesses" } })),
  }];
  return (
    <PublicLayout pageKey="services" lang={lang} jsonLd={ld}
      crumbs={[{ name: SITE[lang].breadcrumbs.services, path: routePath("services", lang) }]}>
      <div className="mx-auto max-w-[1100px] px-6 py-14 md:px-8 md:py-20" data-testid="services-page">
        <H1>{c.h1}</H1>
        <Lead>{c.intro}</Lead>
        <div className="mt-16 space-y-14">
          {c.sections.map((s) => (
            <section key={s.id} id={s.id} data-testid={`service-${s.id}`} className="grid gap-6 border-t border-black/8 pt-10 md:grid-cols-[280px_1fr] md:gap-12">
              <h2 className="font-display text-2xl font-normal text-[#050505]">{s.name}</h2>
              <div className="space-y-4">
                <p className="text-base font-light leading-relaxed text-[#6b6f6c]">{s.problem}</p>
                <p className="text-base font-light leading-relaxed text-[#2a2b29]">{s.solution}</p>
                <p className="text-sm font-medium text-[#0e7c6b]">{s.audience}</p>
              </div>
            </section>
          ))}
        </div>
        <Link to={routePath("events", lang)} data-testid="services-events-card"
          className="group mt-16 block overflow-hidden rounded-2xl bg-[#0a0a0b]">
          <div className="grid md:grid-cols-2">
            <div className="flex flex-col justify-center p-10 md:p-12">
              <p className="overline mb-4 text-white/40">{SITE[lang].events.servicesCard.name}</p>
              <p className="max-w-md text-lg font-light leading-relaxed text-white/80">{SITE[lang].events.servicesCard.text}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#2aa08c]">{SITE[lang].events.servicesCard.cta} →</span>
            </div>
            <img src="/events/madrid.jpg" alt={SITE[lang].events.alt.madrid} loading="lazy" width="1920" height="1283"
              className="h-full min-h-[240px] w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]" />
          </div>
        </Link>
        <SectionCta title={c.cta.title} text={c.cta.text} lang={lang}
          onClick={() => track(EVENTS.CTA_CLICK, { cta: "services_contact" })} />
      </div>
    </PublicLayout>
  );
}
